import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { logUI } from "../../api/andyliticsApi";
import { rxRoute } from "../../helpers/formatting";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
import MiniSpinner from "../common/MiniSpinner";
import PharmacyTile from "./PharmacyTile";
import UnLinkedTransfer from "./UnLinkedTransfer";
import ErrorLoadingTileMessage from "../common/ErrorLoadingTileMessage";
import ResourceSubTile from "../dashboard/ResourceSubTile";
import ResourceSubDescription from '../dashboard/ResourceSubDescription';

const PharmacyAllTile = (props) => {

    const { rxDown, hasPharmacyLogin,
        isLinkDialogOpen, waitingOnPharmacy,
        defaultPharmacy, pharmacyDetails, pharmacyServiceError,
        waitingOnUnLinkedRxTransfer, unlinkedTransferData,
        archivingUnlinkedRxTransferSuccess,
        getPharmacyDashBoardData, unlinkedRxTransfer,
        serverData, userDetails
    } = props;

    useEffect(() => {
        if (!rxDown && hasPharmacyLogin) { // logUI("MBHWeb.DashBoard.Rx.GetPharmacy", new Date(), Tools.getURLPath());
            logUI("MBHWeb.Dashboard.Load.Rx", new Date(), Tools.getURLPath());
            getPharmacyDashBoardData(userDetails);
        } else { // logUI("MBHWeb.DashBoard.Rx.UnlinkedTransfer", new Date(), Tools.getURLPath());
            logUI("MBHWeb.Dashboard.Unlinked", new Date(), Tools.getURLPath());
            unlinkedRxTransfer(null); // need to pass the proxyId, once pharmacy proxies implemented, for now its null.
        }
    }, [userDetails]);

    const showPharmacy = !isLinkDialogOpen && !rxDown && hasPharmacyLogin;
    const isWaitingOnPharmacy = !pharmacyServiceError && (typeof waitingOnPharmacy === 'undefined' || waitingOnPharmacy || typeof pharmacyDetails === "undefined" || pharmacyDetails === null);
    const isWaitingOnTransferData = typeof waitingOnUnLinkedRxTransfer === 'undefined' || waitingOnUnLinkedRxTransfer;
    const showTransferData = (unlinkedTransferData && !archivingUnlinkedRxTransferSuccess) || (unlinkedTransferData && archivingUnlinkedRxTransferSuccess);
    const linkHeading = (!rxDown && !showPharmacy) ? (isWaitingOnTransferData ? false : !showTransferData) : false;

    // Allow user to navigate before data loads only if they has pharmacy - Pharmacy
    let rxHome = { href: rxRoute('rxHome') };
    let findPharmacy = { href: serverData.pharmacyAppUrl + 'findPharmacy' };

    const pathname = (typeof window !== "undefined") ? window.location.href.toLowerCase() : "";
    if (pathname.indexOf('localhost') > -1) {
        rxHome = { to: { pathname: '/pharmacy' } };
        findPharmacy = { to: { pathname: '/pharmacyFindPharmacy' } };
    }

    return (
        <ResourceSubTile
            className="pharmacy-tile"
            heading={msgs.PharmacyTileName}
            disabled={rxDown}
            linkHeading={linkHeading}
            customLink={{ ...findPharmacy }}
            content={
                <div className="row pharmacy-tile__content">
                    <div className="col-12">
                        {!rxDown
                            ? <React.Fragment>
                                {showPharmacy
                                    ? isWaitingOnPharmacy
                                        ? <MiniSpinner />
                                        : <PharmacyTile
                                            defaultPharmacy={defaultPharmacy}
                                            error={pharmacyServiceError}
                                            pharmacyDetails={pharmacyDetails}
                                            rxHome={rxHome}
                                        />
                                    : isWaitingOnTransferData
                                        ? <MiniSpinner />
                                        : showTransferData
                                            ? <UnLinkedTransfer
                                                unlinkedTransferData={unlinkedTransferData} />
                                            : <ResourceSubDescription description="Find a pharmacy near you." />
                                }
                            </React.Fragment>
                            : <ErrorLoadingTileMessage />
                        }
                    </div>
                </div>
            }
        />
    )
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.sso.userDetails,
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        pharmacyDetails: state.pharmacy.pharmacyDashboardDetails,
        defaultPharmacy: state.pharmacy.defaultPharmacy,
        isLinkDialogOpen: state.pharmacy.isLinkDialogOpen,
        waitingOnPharmacy: state.pharmacy.waitingOnPharmacy,
        pharmacyServiceError: state.pharmacy.pharmacyError,
        unlinkedTransferData: state.pharmacy.unLinkedRxTransfer,
        archivingUnlinkedRxTransferSuccess: state.pharmacy.archivingUnlinkedRxTransferSuccess ? state.pharmacy.archivingUnlinkedRxTransferSuccess : false,
        waitingOnUnLinkedRxTransfer: state.pharmacy.waitingOnUnLinkedRxTransfer,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        serverData: state.session.serverData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getPharmacyDashBoardData: (userDetails) => {
            dispatch({ type: types.LOAD_PHARMACYDASHBOARD_START, userDetails: userDetails });
        },
        unlinkedRxTransfer: (proxyId) => {
            dispatch({
                type: types.UNLINK_RX_TRANSFER_START,
                payload: {
                    proxyId: proxyId
                }
            });
        },
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PharmacyAllTile));